import React from 'react'
import { LoginFB } from '../../../core/LoginFB'
import { LoginGGL } from '../../../core/LoginGGL'
import { useAppDispatch } from '../../../redux/hooks'
import { closeModal } from '../../../redux/slices/modalSlice'
import { ModalCssAnimation } from '../ModalManager'

const LoginModal: React.FC = () => {
	const dispatch = useAppDispatch()

	return (
		<div className={`login-modal ${ModalCssAnimation}`}>
			<div className="close-btn" onClick={() => dispatch(closeModal())}>
				<div className="close-icon"></div>
			</div>
			<div className="login-modal-image"></div>
			<div className="login-modal-title">Time for an adventure!</div>
			<div className="ggl-button-container">
				<LoginGGL />
			</div>
			<LoginFB />
		</div>
	)
}

export default LoginModal
